module.exports = __webpack_public_path__ + "97daf7ca7bd3bbbc289a7cd7fd4801ad.svg";